module.exports = __webpack_public_path__ + "static/img/addnextfromlist.b4a2e48.png";